import { FC, PropsWithChildren } from "react";

import {
  ProducePollingContext,
  useProducePollingCtxProvider,
} from "@ryde/redux";

export const ProducePollingContextWrapper: FC<PropsWithChildren> = ({
  children,
}) => {
  const hookData = useProducePollingCtxProvider();

  return (
    <ProducePollingContext.Provider value={hookData}>
      {children}
    </ProducePollingContext.Provider>
  );
};
